<template>
  <div>
    <div class="precarriage-list">
      <div class="precarriage-list__multiselects">
        <div class="precarriage-list__multiselects--save">
          <form-button
            style="grid-column: 2"
            @onClick="savePrecarriage">
            Save PrecarriageList
          </form-button>
        </div>
        <div class="precarriage-list__multiselects--destination">
          <form-label>Destination</form-label>
          <form-filtered-multiselect
            v-model="destination"
            :options="preCarriageDestination"
            track-by="value"
            label="label"
            style="grid-column: 2"
            @input="onDestinationSelected" />
        </div>
      </div>
      <table>
        <thead>
          <tr class="precarriage-list__head">
            <th />
            <th
              v-for="(header, index) in tableFields"
              :key="'dashboardPrecarriageHeader' + index">
              <span />
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(precarriage, precarriageIndex) in preCarriageRoutes"
            :key="'precarriageRoutesTable' + precarriageIndex">
            <td>
              <form-checkbox
                @checkboxChanged="onPreCarriageSelected(precarriage, $event)" />
            </td>

            <td
              v-for="(field, fieldIndex) in tableFields"
              :key="'dashboardPrecariageField' + precarriageIndex + '.' + fieldIndex"
              class="precarriage-list__field">
              <span>
                {{ formatField(precarriage[field.name], field.type) }}
              </span>
            </td>
          </tr>
          <tr
            v-for="(precarriage, precarriageIndex) in preCarriageList"
            :key="'precarriageListTable' + precarriageIndex">
            <td class="precarriage-records">
              <form-checkbox
                :checked="ifContainsTimestamp(precarriage.PreCarriage_Route_Records_Timestamp)"
                :disabled="ifDateIsInPast(precarriage.PreCarriage_Route_Records_Timestamp)"
                @checkboxChanged="onPreCarriageSelected(precarriage, !$event)" />
            </td>
            <td
              v-for="(field, fieldIndex) in tableFields"
              :key="'dashboardPrecariageField' + precarriageIndex + '.' + fieldIndex"
              class="precarriage-list__field precarriage-records">
              <span>
                {{ formatField(precarriage[field.name], field.type) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Helpers from '@/helpers.vue'
import constants from '@/constants'
import moment from 'moment'

export default {
  name: 'PreCarriageRouteListTable',
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'PreCarriage_Route_Records_Name', label: 'Name', type: 'String' },
        { name: 'PreCarriage_Route_Records_ETD', label: 'Est. Time of Departure', type: 'String' },
        { name: 'PreCarriage_Route_Records_ETA', label: 'Est. Time of Arrival', type: 'String' },
        { name: 'PreCarriage_Route_Records_Collection', label: 'Collection point', type: 'String' },
        { name: 'PreCarriage_Route_Records_Destination', label: 'Destination', type: 'String' },
        { name: 'PreCarriage_Route_Records_Vechicle_Name', label: 'Vehicle', type: 'String' },
        { name: 'PreCarriage_Route_Records_Provider_Name', label: 'Provider', type: 'String' },
        { name: 'PreCarriage_Route_Customer_Name', label: 'Customer', type: 'String' },
        { name: 'PreCarriage_Route_Records_Timestamp', label: 'Timestamp', type: 'Date' }
      ],
      preCarriageRoutes: [],
      preCarriageRouteOptions: [],
      destination: [],
      constants
    }
  },
  computed: {
    ...mapGetters('preCarriageRoutes', ['preCarriageList', 'preCarriageFilter', 'preCarriageDestination'])
  },
  watch: {
    preCarriageList: {
      handler: function () {
        this.preCarriageRoutes = this.mapStoredPreCarriageRoutes()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('preCarriageRoutes', ['loadPreCarriageList', 'savePreCarriageList', 'loadPreCarriageFilter']),
    editData (precarriage) {
      this.$router.push({ name: 'precarriage-edit', params: precarriage })
    },
    onPreCarriageSelected (preCarriage, event) {
      // the timestamp should have always a value, if empty get todays date
      const preCariageItem = {
        Precarriage_Route_ID: preCarriage.PreCarriage_Route_ID, // required
        Precarriage_Route_Record_ID: preCarriage.PreCarriage_Route_Records_ID || null, // optional, in case the record is being updated should containg the id from records table
        Precarriage_Route_Record_Timestamp: preCarriage.PreCarriage_Route_Records_Timestamp || moment().format('YYYY-MM-DD') // required
      }
      // if precariage true add preCariageItem to the to preCarriageRouteOptions else remove it
      if (event) {
        this.preCarriageRouteOptions.push(preCariageItem)
      } else {
        const index = this.preCarriageRouteOptions.findIndex(a => a.PreCarriage_Route_ID === preCarriage.PreCarriage_Route_ID)
        this.preCarriageRouteOptions.splice(index, 1)
      }
    },
    savePrecarriage () {
      this.savePreCarriageList(this.preCarriageRouteOptions).then(() => {
        this.preCarriageRouteOptions = []
        var filter = {
          Provider_IDs: [],
          From_Date: moment().format('YYYY-MM-DD'),
          To_Date: moment().format('YYYY-MM-DD'),
          Destination: []
        }
        // load all default precarriage + dhe saved ones
        this.loadPreCarriageList(filter).then(() => {
          this.loadPreCarriageFilter(filter)
        })
        this.$forceUpdate()
      })
    },
    onDestinationSelected (destination) {
      this.destination = destination
      this.preCarriageRoutes = this.mapStoredPreCarriageRoutes()
    },
    // Special formatting for fields
    formatField (field, type) {
      if (type === 'Date') {
        return this.formatDate(field, false, 'YYYY-MM-DD')
      } else if (type === 'Time') {
        return this.formatDate(field, true, 'YYYY-MM-DD HH:mm')
      } else if (type === 'Number.2') {
        return this.numberFormat(field, 2, false)
      }
      // empty fields will be removed
      if (field == null || field === 0) {
        return ''
      }
      return field
    },
    mapStoredPreCarriageRoutes () {
      var storedPreCarriageRoute = JSON.parse(window.sessionStorage.getItem('PreCarriageRoute_List'))
      // change the list based on filtering
      if (this.destination.length > 0) {
        storedPreCarriageRoute = storedPreCarriageRoute.filter(a => this.destination.includes(a.PreCarriage_Route_Destination))
      }
      if (!storedPreCarriageRoute) return []
      const mappedPreCarriageRoutes = storedPreCarriageRoute.map((route) => ({
        PreCarriage_Route_Records_Name: route.PreCarriage_Route_Name,
        PreCarriage_Route_Records_ETD: route.PreCarriage_Route_ETD,
        PreCarriage_Route_Records_ETA: route.PreCarriage_Route_ETA,
        PreCarriage_Route_Records_Collection: route.PreCarriage_Route_Collection,
        PreCarriage_Route_Records_Destination: route.PreCarriage_Route_Destination,
        PreCarriage_Route_Records_Vechicle_Name: this.findVehicleName(route.PreCarriage_Route_Vechicle_ID),
        PreCarriage_Route_Records_Provider_Name: this.findProviderName(route.PreCarriage_Route_Provider_ID),
        PreCarriage_Route_Customer_Name: route.PreCarriage_Route_Customer_Name,
        PreCarriage_Route_Records_Timestamp: '',
        // PreCarriage_Route_Records_Timestamp should be empty in case of not saved yet or the date of the saved record
        PreCarriage_Route_ID: route.PreCarriage_Route_ID,
        // PreCarriage_Route_Records_ID - the records id in case we have values filtered
        PreCarriage_Route_Records_ID: ''
      }))
      return mappedPreCarriageRoutes.filter((preCarriage) => {
        const preCarriageRouteRecord = this.findPreCariageRouteRecordById(preCarriage)
        if (!preCarriageRouteRecord) return true
        return this.ifDateIsInPast(preCarriageRouteRecord.PreCarriage_Route_Records_Timestamp)
      })
    },
    // function to find the vehicle name and provider name based on the id
    findPreCariageRouteOptionById (precarriage) {
      var preCarriageRouteOption = this.preCarriageRouteOptions.find(a => a.PreCarriage_Route_ID === precarriage.PreCarriage_Route_ID)
      return preCarriageRouteOption
    },
    findPreCariageRouteRecordById (precarriage) {
      var preCarriageRouteRecord = this.preCarriageList.find(a => a.PreCarriage_Route_ID === precarriage.PreCarriage_Route_ID)
      return preCarriageRouteRecord
    },
    // function to find the vehicle name and provider name based on the id
    findVehicleName (id) {
      const vehicles = JSON.parse(window.sessionStorage.getItem('Vehicle_List'))
      var vehicleName = vehicles.find(a => a.Vehicle_ID === id).Vehicle_Type
      return vehicleName
    },
    // function to find the provider name and provider name based on the id
    findProviderName (id) {
      const providers = JSON.parse(window.sessionStorage.getItem('Active_Provider_List'))
      var providerObj = providers.find(a => a.Provider_ID === id)
      var providerName = ''
      if (providerObj !== undefined) providerName = providerObj.Provider_Name
      return providerName
    },
    ifDateIsInPast (date) {
      return moment(date).isBefore(moment().format('YYYY-MM-DD'))
    },
    ifContainsTimestamp (date) {
      return date !== ''
    }
  }
}
</script>
<style lang="scss">
  @import '../../variables.scss';

  .precarriage-list {
    width: 100%;
    padding: 0 20px;
    overflow: auto;
    // padding-left: 1%;
    // display: flex;

    &__fields {
      display: grid;
      grid-template-columns: 19% 19% 19% 19% 19%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
    }
    &__multiselects {
      display: grid;
      padding: 20px 0;
      width: 100%;
      grid-template-columns: 250px 250px 60px 74px;

      &--save {
        grid-column: 1;
        grid-row: 1;
      }

      &--destination {
        position: absolute;
        right: 50px;
        width: 20%;
      }

      grid-gap: 10px;
      .spl-button {
        margin: 22px 7px 0 0;
      }
    }
    .precarriage-records {
      background-color: #eee !important;
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
      padding-bottom: 100px;
      width: -webkit-fill-available;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
  }
</style>
